export class UserForm {

  constructor(
    public username: string,
    public password: string,
    public mode: string
  ) {  }

}
